// import { useEffect, useState } from "react";
// import config from '../../config';
// import './DueCus.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { ChevronUp, ChevronDown, Eye } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import React from 'react';

// const DuePaymentsReceived = () => {
//   const expandedColumns = [
//     'Invoice Number',
//     'Customer Name',
//     'Customer Office',
//     'Payment Type',
//     'Cheque Details',
//     'Dated Cheques',
//     'Paid Amount',
//     'Days Left',
//     'View',
//     'Action'
//   ];

//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [expandedRows, setExpandedRows] = useState([]);
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1); // Initially 1, will be updated to last page
//   const [itemsPerPage] = useState(10); // Number of items per page

//   const navigate = useNavigate();

//   useEffect(() => {
//     fetchDueCustomer();
//   }, []);

//   // Set currentPage to the last page when data is loaded
//   useEffect(() => {
//     if (data.length > 0) {
//       const totalPages = Math.ceil(data.length / itemsPerPage);
//       setCurrentPage(totalPages); // Set to last page after data is fetched
//     }
//   }, [data, itemsPerPage]);

//   const fetchCustomerName = async (cusId) => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
//       if (response.ok) {
//         const customer = await response.json();
//         return customer.cusName;
//       }
//       return 'Unknown Customer';
//     } catch {
//       return 'Unknown Customer';
//     }
//   };

//   const fetchInvoiceNumber = async (invoiceId) => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/invoice/${invoiceId}`);
//       if (response.ok) {
//         const invoice = await response.json();
//         return invoice.invoiceNo;
//       }
//       return 'Unknown Invoice';
//     } catch {
//       return 'Unknown Invoice';
//     }
//   };

//   const calculateDaysLeft = (datedCheque) => {
//     const today = new Date();
//     const chequeDate = new Date(datedCheque);
//     today.setHours(0, 0, 0, 0);
//     chequeDate.setHours(0, 0, 0, 0);

//     const timeDifference = chequeDate.getTime() - today.getTime();
//     const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

//     if (daysDifference === 0) {
//       return { text: "Due Today", color: "orange" };
//     } else if (daysDifference < 0) {
//       return { text: "Clear", color: "red" };
//     } else {
//       return { text: `${daysDifference} Days Left`, color: "green" };
//     }
//   };

//   const fetchDueCustomer = async () => {
//     try {
//       const response = await fetch(`${config.BASE_URL}/duecustomers`);
//       if (!response.ok) {
//         setError('Failed to fetch Due Customers');
//         return;
//       }
//       const dueCustomers = await response.json();
//       const chequeDueCustomers = dueCustomers.filter(dueCustomer => dueCustomer.payType === 'cheque' || dueCustomer.payType === 'cash');

//       const customerNameCache = {};
//       const invoiceNumberCache = {};

//       const groupedData = chequeDueCustomers.reduce((acc, dueCustomer) => {
//         const key = `${dueCustomer.invoiceId}-${dueCustomer.cusId}`;
//         if (!acc[key]) {
//           acc[key] = {
//             invoiceId: dueCustomer.invoiceId,
//             cusId: dueCustomer.cusId,
//             transactions: [],
//             totalPaidAmount: 0
//           };
//         }
//         acc[key].transactions.push(dueCustomer);
//         acc[key].totalPaidAmount += dueCustomer.paidAmount;
//         return acc;
//       }, {});

//       const formattedData = await Promise.all(
//         Object.values(groupedData).map(async (group) => {
//           let customerName = customerNameCache[group.cusId];
//           if (!customerName) {
//             customerName = await fetchCustomerName(group.cusId);
//             customerNameCache[group.cusId] = customerName;
//           }

//           let invoiceNo = invoiceNumberCache[group.invoiceId];
//           if (!invoiceNo) {
//             invoiceNo = await fetchInvoiceNumber(group.invoiceId);
//             invoiceNumberCache[group.invoiceId] = invoiceNo;
//           }

//           return {
//             invoiceId: group.invoiceId,
//             invoiceNo,
//             customerName,
//             customerOffice: group.transactions[0].customer?.cusOffice || '-',
//             cusId: group.cusId,
//             transactions: group.transactions.map(transaction => ({
//               ...transaction,
//               payType: transaction.payType || 'unknown',
//               chequeDetail: transaction.payType === 'cash' ? '-' : transaction.chequeDetail,
//               datedCheque: transaction.payType === 'cash' ? '-' : transaction.datedCheque
//             })),
//             totalPaidAmount: group.totalPaidAmount
//           };
//         })
//       );

//       setData(formattedData.filter(Boolean));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const toggleRowExpansion = (key) => {
//     setExpandedRows(prev =>
//       prev.includes(key)
//         ? prev.filter(item => item !== key)
//         : [...prev, key]
//     );
//   };

//   const handleViewDetails = (cusId) => {
//     if (!cusId || cusId === "-") {
//       alert("Customer ID not available");
//       return;
//     }
//     navigate(`/cus-due/${cusId}`);
//   };

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(data.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <div>
//       <div className="scrolling-container">
//         <div className="new-sales-container">
//           <h4>Payments Received (Cash, Cheque)</h4>

//           {isLoading ? (
//             <p>Loading...</p>
//           ) : error ? (
//             <p>No Data: {error}</p>
//           ) : null}

//           <table className="due-cus-table">
//             <thead>
//               <tr>
//                 {expandedColumns.map((column, index) => (
//                   <th key={index}>{column}</th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {currentItems.map((row) => {
//                 const rowKey = `${row.invoiceId}-${row.cusId}`;
//                 const isExpanded = expandedRows.includes(rowKey);
//                 const hasMultipleTransactions = row.transactions.length > 1;
//                 const firstTransaction = row.transactions[0];

//                 return (
//                   <React.Fragment key={rowKey}>
//                     <tr>
//                       <td>{row.invoiceNo}</td>
//                       <td>{row.customerName}</td>
//                       <td>{row.customerOffice}</td>
//                       <td>{hasMultipleTransactions ? '-' : firstTransaction.payType}</td>
//                       <td>{hasMultipleTransactions ? '-' : firstTransaction.chequeDetail}</td>
//                       <td>{hasMultipleTransactions ? '-' : (firstTransaction.payType === 'cash' ? '-' : new Date(firstTransaction.datedCheque).toLocaleString())}</td>
//                       <td>{hasMultipleTransactions ? row.totalPaidAmount : firstTransaction.paidAmount}</td>
//                       <td>
//                         {hasMultipleTransactions ? '-' : (
//                           firstTransaction.payType === 'cash' ? '-' : (
//                             <span style={{ color: calculateDaysLeft(firstTransaction.datedCheque).color }}>
//                               {calculateDaysLeft(firstTransaction.datedCheque).text}
//                             </span>
//                           )
//                         )}
//                       </td>
//                       <td>
//                         <button
//                           className="btn btn-warning"
//                           onClick={() => handleViewDetails(row.cusId)}
//                         >
//                           <Eye size={16} />
//                         </button>
//                       </td>
//                       <td>
//                         <div className="d-flex justify-content-between align-items-center">
//                           {hasMultipleTransactions && (
//                             <button
//                               className="btn btn-primary"
//                               onClick={() => toggleRowExpansion(rowKey)}
//                             >
//                               {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
//                             </button>
//                           )}
//                         </div>
//                       </td>
//                     </tr>
//                     {isExpanded && hasMultipleTransactions && (
//                       <tr className="expanded-row">
//                         <td colSpan={expandedColumns.length}>
//                           <table className="expanded-table">
//                             <thead>
//                               <tr>
//                                 {expandedColumns.slice(0, -1).map((column, index) => (
//                                   <th key={index}>{column}</th>
//                                 ))}
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {row.transactions.map((transaction, tIndex) => {
//                                 const daysLeftInfo = transaction.payType === 'cash' ? { text: '-', color: 'black' } : calculateDaysLeft(transaction.datedCheque);
//                                 return (
//                                   <tr key={`${rowKey}-${tIndex}`}>
//                                     <td>{row.invoiceNo}</td>
//                                     <td>{row.customerName}</td>
//                                     <td>{row.customerOffice}</td>
//                                     <td>{transaction.payType}</td>
//                                     <td>{transaction.chequeDetail}</td>
//                                     <td>{transaction.payType === 'cash' ? '-' : new Date(transaction.datedCheque).toLocaleString()}</td>
//                                     <td>{transaction.paidAmount}</td>
//                                     <td style={{ color: daysLeftInfo.color }}>{daysLeftInfo.text}</td>
//                                   </tr>
//                                 );
//                               })}
//                             </tbody>
//                           </table>
//                         </td>
//                       </tr>
//                     )}
//                   </React.Fragment>
//                 );
//               })}
//             </tbody>
//           </table>

//           {/* Pagination component */}
//           {totalPages > 1 && (
//             <div className="pagination justify-content-center mt-3 mb-3">
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handlePageChange(currentPage - 1)}
//                 disabled={currentPage <= 1}
//               >
//                 Previous
//               </button>
              
//               {/* Show first page */}
//               {currentPage > 2 && (
//                 <>
//                   <span
//                     className={`mx-1 px-2 py-1 border ${1 === currentPage ? 'border-primary fw-bold' : 'border-transparent'}`}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handlePageChange(1)}
//                   >
//                     1
//                   </span>
//                   {currentPage > 3 && <span className="mx-1">...</span>}
//                 </>
//               )}

//               {/* Current page and surrounding pages */}
//               {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                 let page;
//                 if (currentPage <= 3) {
//                   page = i + 1;
//                 } else if (currentPage >= totalPages - 2) {
//                   page = totalPages - 4 + i;
//                 } else {
//                   page = currentPage - 2 + i;
//                 }
//                 return page > 0 && page <= totalPages ? (
//                   <span
//                     key={page}
//                     className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handlePageChange(page)}
//                   >
//                     {page}
//                   </span>
//                 ) : null;
//               })}

//               {/* Show last page */}
//               {currentPage < totalPages - 1 && (
//                 <>
//                   {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
//                   <span
//                     className={`mx-1 px-2 py-1 border ${totalPages === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => handlePageChange(totalPages)}
//                   >
//                     {totalPages}
//                   </span>
//                 </>
//               )}
              
//               <button
//                 className="btn btn-primary"
//                 onClick={() => handlePageChange(currentPage + 1)}
//                 disabled={currentPage >= totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DuePaymentsReceived;

import { useEffect, useState } from "react";
import config from '../../config';
import './DueCus.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ChevronUp, ChevronDown, Eye, Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import React from 'react';

const DuePaymentsReceived = () => {
  const expandedColumns = [
    'Invoice Number',
    'Customer Name',
    'Customer Office',
    'Payment Type',
    'Cheque Details',
    'Dated Cheques',
    'Paid Amount',
    'Days Left',
    'Action'
  ];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const navigate = useNavigate();

  useEffect(() => {
    fetchDueCustomer();
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      const totalPages = Math.ceil(data.length / itemsPerPage);
      setCurrentPage(totalPages);
    }
  }, [data, itemsPerPage]);

  const fetchDueCustomer = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${config.BASE_URL}/duecustomers`);
      if (!response.ok) {
        setError('Failed to fetch Due Customers');
        return;
      }
      const dueCustomers = await response.json();
      const chequeDueCustomers = dueCustomers.filter(dueCustomer => 
        dueCustomer.payType === 'cheque' || dueCustomer.payType === 'cash'
      );

      const customerNameCache = {};
      const invoiceNumberCache = {};

      const groupedData = chequeDueCustomers.reduce((acc, dueCustomer) => {
        const key = `${dueCustomer.invoiceId}-${dueCustomer.cusId}`;
        if (!acc[key]) {
          acc[key] = {
            invoiceId: dueCustomer.invoiceId,
            cusId: dueCustomer.cusId,
            transactions: [],
            totalPaidAmount: 0
          };
        }
        acc[key].transactions.push(dueCustomer);
        acc[key].totalPaidAmount += dueCustomer.paidAmount;
        return acc;
      }, {});

      const formattedData = await Promise.all(
        Object.values(groupedData).map(async (group) => {
          let customerName = customerNameCache[group.cusId];
          if (!customerName) {
            customerName = await fetchCustomerName(group.cusId);
            customerNameCache[group.cusId] = customerName;
          }

          let invoiceNo = invoiceNumberCache[group.invoiceId];
          if (!invoiceNo) {
            invoiceNo = await fetchInvoiceNumber(group.invoiceId);
            invoiceNumberCache[group.invoiceId] = invoiceNo;
          }

          return {
            invoiceId: group.invoiceId,
            invoiceNo,
            customerName,
            customerOffice: group.transactions[0].customer?.cusOffice || '-',
            cusId: group.cusId,
            transactions: group.transactions.map(transaction => ({
              ...transaction,
              payType: transaction.payType || 'unknown',
              chequeDetail: transaction.payType === 'cash' ? '-' : transaction.chequeDetail,
              datedCheque: transaction.payType === 'cash' ? '-' : transaction.datedCheque
            })),
            totalPaidAmount: group.totalPaidAmount
          };
        })
      );

      setData(formattedData.filter(Boolean));
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomerName = async (cusId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/customer/${cusId}`);
      if (response.ok) {
        const customer = await response.json();
        return customer.cusName;
      }
      return 'Unknown Customer';
    } catch {
      return 'Unknown Customer';
    }
  };

  const fetchInvoiceNumber = async (invoiceId) => {
    try {
      const response = await fetch(`${config.BASE_URL}/invoice/${invoiceId}`);
      if (response.ok) {
        const invoice = await response.json();
        return invoice.invoiceNo;
      }
      return 'Unknown Invoice';
    } catch {
      return 'Unknown Invoice';
    }
  };

  const calculateDaysLeft = (datedCheque) => {
    const today = new Date();
    const chequeDate = new Date(datedCheque);
    today.setHours(0, 0, 0, 0);
    chequeDate.setHours(0, 0, 0, 0);

    const timeDifference = chequeDate.getTime() - today.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      return { text: "Due Today", color: "orange" };
    } else if (daysDifference < 0) {
      return { text: "Clear", color: "red" };
    } else {
      return { text: `${daysDifference} Days Left`, color: "green" };
    }
  };

  const toggleRowExpansion = (key) => {
    setExpandedRows(prev =>
      prev.includes(key)
        ? prev.filter(item => item !== key)
        : [...prev, key]
    );
  };

  const handleViewDetails = (cusId) => {
    if (!cusId || cusId === "-") {
      alert("Customer ID not available");
      return;
    }
    navigate(`/cus-due/${cusId}`);
  };

  const handleDelete = async (duecustomerId, transactionId, paidAmount) => {
    if (!window.confirm("Are you sure you want to delete this payment?")) {
      return;
    }

    try {
      const response = await fetch(`${config.BASE_URL}/duecustomer/${duecustomerId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          transactionId,
          paidAmount
        })
      });

      if (!response.ok) {
        throw new Error('Failed to delete payment');
      }

      // Refresh the data
      fetchDueCustomer();
    } catch (error) {
      console.error('Error deleting payment:', error);
      alert('Failed to delete payment');
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      <div className="scrolling-container">
        <div className="new-sales-container">
          <h4>Payments Received (Cash, Cheque)</h4>

          {isLoading ? (
            <p>Loading...</p>
          ) : error ? (
            <p>No Data: {error}</p>
          ) : null}

          <table className="due-cus-table">
            <thead>
              <tr>
                {expandedColumns.map((column, index) => (
                  <th key={index}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((row) => {
                const rowKey = `${row.invoiceId}-${row.cusId}`;
                const isExpanded = expandedRows.includes(rowKey);
                const hasMultipleTransactions = row.transactions.length > 1;
                const firstTransaction = row.transactions[0];

                return (
                  <React.Fragment key={rowKey}>
                    <tr>
                      <td>{row.invoiceNo}</td>
                      <td>{row.customerName}</td>
                      <td>{row.customerOffice}</td>
                      <td>{hasMultipleTransactions ? '-' : firstTransaction.payType}</td>
                      <td>{hasMultipleTransactions ? '-' : firstTransaction.chequeDetail}</td>
                      <td>{hasMultipleTransactions ? '-' : (firstTransaction.payType === 'cash' ? '-' : new Date(firstTransaction.datedCheque).toLocaleString())}</td>
                      <td>{hasMultipleTransactions ? row.totalPaidAmount : firstTransaction.paidAmount}</td>
                      <td>
                        {hasMultipleTransactions ? '-' : (
                          firstTransaction.payType === 'cash' ? '-' : (
                            <span style={{ color: calculateDaysLeft(firstTransaction.datedCheque).color }}>
                              {calculateDaysLeft(firstTransaction.datedCheque).text}
                            </span>
                          )
                        )}
                      </td>
                      <td>
                        <div className="d-flex justify-content-between align-items-center">
                          <button
                            className="btn btn-warning me-2"
                            onClick={() => handleViewDetails(row.cusId)}
                          >
                            <Eye size={16} />
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleDelete(
                              firstTransaction.duecustomerId,
                              firstTransaction.transactionId,
                              firstTransaction.paidAmount
                            )}
                          >
                            <Trash2 size={16} />
                          </button>
                          {hasMultipleTransactions && (
                            <button
                              className="btn btn-primary"
                              onClick={() => toggleRowExpansion(rowKey)}
                            >
                              {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                    {isExpanded && hasMultipleTransactions && (
                      <tr className="expanded-row">
                        <td colSpan={expandedColumns.length}>
                          <table className="expanded-table">
                            <thead>
                              <tr>
                                {expandedColumns.slice(0, -1).map((column, index) => (
                                  <th key={index}>{column}</th>
                                ))}
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {row.transactions.map((transaction, tIndex) => {
                                const daysLeftInfo = transaction.payType === 'cash' ? { text: '-', color: 'black' } : calculateDaysLeft(transaction.datedCheque);
                                return (
                                  <tr key={`${rowKey}-${tIndex}`}>
                                    <td>{row.invoiceNo}</td>
                                    <td>{row.customerName}</td>
                                    <td>{row.customerOffice}</td>
                                    <td>{transaction.payType}</td>
                                    <td>{transaction.chequeDetail}</td>
                                    <td>{transaction.payType === 'cash' ? '-' : new Date(transaction.datedCheque).toLocaleString()}</td>
                                    <td>{transaction.paidAmount}</td>
                                    <td style={{ color: daysLeftInfo.color }}>{daysLeftInfo.text}</td>
                                    <td>
                                      <button
                                        className="btn btn-danger"
                                        onClick={() => handleDelete(
                                          transaction.duecustomerId,
                                          transaction.transactionId,
                                          transaction.paidAmount
                                        )}
                                      >
                                        <Trash2 size={16} />
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>

          {/* Pagination component */}
          {totalPages > 1 && (
            <div className="pagination justify-content-center mt-3 mb-3">
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage <= 1}
              >
                Previous
              </button>
              
              {/* Show first page */}
              {currentPage > 2 && (
                <>
                  <span
                    className={`mx-1 px-2 py-1 border ${1 === currentPage ? 'border-primary fw-bold' : 'border-transparent'}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePageChange(1)}
                  >
                    1
                  </span>
                  {currentPage > 3 && <span className="mx-1">...</span>}
                </>
              )}

              {/* Current page and surrounding pages */}
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let page;
                if (currentPage <= 3) {
                  page = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  page = totalPages - 4 + i;
                } else {
                  page = currentPage - 2 + i;
                }
                return page > 0 && page <= totalPages ? (
                  <span
                    key={page}
                    className={`mx-1 px-2 py-1 border ${page === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </span>
                ) : null;
              })}

              {/* Show last page */}
              {currentPage < totalPages - 1 && (
                <>
                  {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                  <span
                    className={`mx-1 px-2 py-1 border ${totalPages === currentPage ? 'border-dark fw-bold' : 'border-transparent'}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </span>
                </>
              )}
              
              <button
                className="btn btn-primary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage >= totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DuePaymentsReceived;